import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { joinRouteMatchPath, ROUTES } from '@futrli/shared-services';

import { NotificationBannerManager } from '../../notifications/notification-banner-manager';
import { SyncResultBannerContainer } from '../../notifications/sync-result-banner-container';

export const AppNavbarNotifications = () => (
  <Routes>
    <Route
      path={joinRouteMatchPath(
        '',
        ROUTES.WORKSPACES_ROUTE,
        ROUTES.WORKSPACE_BY_ID_ROUTE,
        ROUTES.ORGANISATION_BY_ID,
        ROUTES.PRODUCT_SLUG_ROUTE,
        '*'
      )}
      element={
        <>
          <SyncResultBannerContainer />
          <NotificationBannerManager />
        </>
      }
    />
  </Routes>
);
